import React from 'react';
import Link from 'next/link';
import { BasicTextStyles } from './BasicText.styled';

const BasicText = () => {
  return (
    <BasicTextStyles>
      <div className="info-card">
        <h5>Homeowner support</h5>
        <p className="caption">
          Need support for your Clayton Built&reg; home? Contact our Customer
          Advocacy Team at <br />
          <a href="tel:18772642812">1-877-264-2812</a> or{' '}
          <a href="mailto:CustomerAdvocacy@claytonhomes.com">
            CustomerAdvocacy@claytonhomes.com
          </a>
        </p>
      </div>

      <div className="info-card">
        <h5>Home office</h5>
        <h6>Mailing address</h6>
        <p className="caption">
          5000 Clayton Road,
          <br />
          Maryville, TN 37804
        </p>

        <h6>Phone</h6>
        <p>
          <a className="tel gtm-call-home-office" href="tel:18653803000">
            (865) 380-3000
          </a>
        </p>
      </div>

      <div className="info-card">
        <h5>Media requests</h5>
        <p className="caption">
          Requests can be emailed to{' '}
          <a href="mailto:media@claytonhomes.com">media@claytonhomes.com</a> or
          you can visit our <Link href="/newsroom/">Newsroom.</Link>
        </p>
      </div>
    </BasicTextStyles>
  );
};

export default BasicText;
